export default {
  loading: false,
  error: false,
  data: {
    bookingExcursions: {
      dataUrl: '/api/booking-excursions',
      submitUrl: '/api/update-excursions'
    },
    flights: {
      dataUrl: '/umbraco/api/tourdepartures/departuredetails'
    },
    visa: {
      dataUrl: '/umbraco/surface/checkoutapi/visas'
    },
  },
  booking: {
    excursions: [],
  },
  holidays: [],
  paymentFrame: null,
  paymentAmount: null,
  paymentSuccess: null,
  paymentError: false,
  cardTypeId: null,
  userDetails: {},
  tabsDisabled: false,
  hideCustomAmountOption: false
};